import React from "react";

import INCMTRTCTBNR from "../assets/Banner/WebBanner/IncomeProtect.png";
import PlanPurchaseProcess from "../components/IncomeProtect/PlanPurchaseProcess";
import banner1 from "../assets/Banner/WebBanner/b2.png";
import Header from "../layout/Header";
import WebDarkMonitor from "../components/CyberProtect/WebDarkMonitor";
import CustomerReviews from "../components/AutomobileAssistance/CustomerReviews";
import HeroSection from "../components/HeroSection";
import logo from "../assets/images/About/about-logo.png";
import FAQ from "../components/FAQ";

const IncomeProtection = () => {
  const FAQdata = [
    {
      question: "What is Income Protection and who should consider it?",
      answer:
        "Income Protection helps you maintain your lifestyle and cover essential expenses if you’re unable to work due to illness, injury, or involuntary job loss. It’s recommended for anyone who relies on their earnings, including salaried employees, professionals, freelancers, and self-employed individuals."
    },
    {
      question: "What situations are typically covered?",
      answer:
        "Most plans cover involuntary unemployment, disability from accident or illness, and some critical illnesses. Always review your policy for specific coverage details."
    },
    {
      question: "How much and how long does Income Protection pay out?",
      answer:
        "Depending on the policy, you can expect a replacement of about 50–70% of your pre-tax income for a set period—either short-term (a few months) or long-term (sometimes until you can work again or up to age 60–65)."
    },
    {
      question: "Are there waiting periods, exclusions, or premium increases to know about?",
      answer:
        "Yes—payments begin after a waiting (‘elimination’) period, usually 30–90 days. Pre-existing medical conditions may be excluded or have waiting periods, and premiums don’t automatically rise after a claim but may change at renewal or review. Always check policy terms."
    },
    {
      question: "Can self-employed or freelancers get coverage?",
      answer:
        "Absolutely. Specialized policies are available for freelancers and business owners, providing tailored coverage for your unique income streams."
    }
  ];
  return (
    <>
      <HeroSection
        bannerImage={banner1}
        heading=" Income Protection"
        description="With Income Protect by Across Assist, we ensure that sudden job
                loss, illness, or temporary disability doesn't put your
                lifestyle, bills, or responsibilities at risk. Designed for
                working professionals earners, this plan provides a financial
                safety net when your regular income stops due to circumstances
                beyond your control.
        "
        image={logo}
        gradientBg="linear-gradient(268.53deg, #1363DF 28.18%, #000000 124.21%)"
        gradientOpacity={0.9}
      />

      <PlanPurchaseProcess />

      <WebDarkMonitor />

      <FAQ
        FAQdata={FAQdata}
        sectionTitle="Frequently Asked Questions"
        sectionDescription="Find answers to the most common questions below. If you need more help, contact our support."
      />

      <CustomerReviews />
    </>
  );
};

export default IncomeProtection;
